// External libraries
import React from 'react';

// Internal modules
import { features, getContent } from '@/lib';
import { SectionHeadingLarge, SectionSubHeading } from '@/components/Headings';
import { BuyNowPayLaterLink } from './BuyNowPayLaterLink';
import { getSubFlowForPaymentHeader } from './utils';

const PaymentSectionHeading = () => {
  const isGuestFlow = features.someActive('isGuestEligible', 'isPOMAEligible');
  const flow = isGuestFlow ? 'guest' : 'signup';
  const subFlow = getSubFlowForPaymentHeader(isGuestFlow);

  return (
    <>
      <SectionHeadingLarge>
        {getContent(`sectionHeaders.payWith.${flow}.${subFlow}`)}
      </SectionHeadingLarge>
      <SectionSubHeading>
        {getContent(`valueProps.payWith.${flow}.${subFlow}`)}
        <BuyNowPayLaterLink />
      </SectionSubHeading>
    </>
  );
};

export { PaymentSectionHeading };
